import {
    EMPTY_APP, UPDATE_TITLE,
    OPEN_MODAL, CLOSE_MODAL,
    OPEN_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL,
    OPEN_PREVIEW_MODAL, CLOSE_PREVIEW_MODAL
} from './constants';

import { classNameForPaddingForWindowsScrollBars } from 'utils/user-agent-tests';

import { clearContentToPreview, setContentPieceToPreview, setContentSetToPreview } from 'containers/ContentPage/store/actions';


export const emptyApp = () => ({
    type: EMPTY_APP
});

export const updateTitle = (data) => ({
    type: UPDATE_TITLE,
    data
});

export const openModal = (data) => {
    // Adding/removing body class here because universal
    let classForScroll = classNameForPaddingForWindowsScrollBars();
    document.body.classList.add('ReactModal--open');
    if(classForScroll != null) {
        document.body.classList.add(classForScroll);
    }
    return {
        type: OPEN_MODAL,
        data
    }
};

export const closeModal = () => {
    // Adding/removing body class here because universal
    document.body.classList.remove('ReactModal--open');
    document.body.classList.remove('ReactModal--Windows');
    document.body.classList.remove('ReactModal--Edge');
    return {
        type: CLOSE_MODAL
    }
};

export const openConfirmModal = (data) => {
    // Adding/removing body class here because universal
    let classForScroll = classNameForPaddingForWindowsScrollBars();
    document.body.classList.add('ReactModal--open-confirm');
    if(classForScroll != null) {
        document.body.classList.add(classForScroll);
    }
    return {
        type: OPEN_CONFIRM_MODAL,
        data
    }
};

export const closeConfirmModal = () => {
    // Adding/removing body class here because universal
    document.body.classList.remove('ReactModal--open-confirm');
    document.body.classList.remove('ReactModal--Windows');
    document.body.classList.remove('ReactModal--Edge');
    return {
        type: CLOSE_CONFIRM_MODAL
    }
};

export const openPreviewModal = () => {
    // Adding/removing body class here because universal
    let classForScroll = classNameForPaddingForWindowsScrollBars();
    document.body.classList.add('ReactModal--open-preview');
    if(classForScroll != null) {
        document.body.classList.add(classForScroll);
    }
    return {
        type: OPEN_PREVIEW_MODAL
    }
};

export const closePreviewModal = () => {
    // Adding/removing body class here because universal
    document.body.classList.remove('ReactModal--open-preview');
    document.body.classList.remove('ReactModal--Windows');
    document.body.classList.remove('ReactModal--Edge');
    return {
        type: CLOSE_PREVIEW_MODAL
    }
};

export const openPreviewModalAndSetContentToPreview = (data) => (dispatch, getState) => {
    if(Object.keys(getState().content.contentPieceToPreview).length === 0) {
        dispatch(setContentPieceToPreview(data[0]));
    }
    dispatch(setContentSetToPreview(data));
    dispatch(openPreviewModal());
};

export const closePreviewModalAndClearContentToPreview = () => (dispatch) => {
    dispatch(clearContentToPreview());
    dispatch(closePreviewModal());
};



// WEBPACK FOOTER //
// ./src/containers/App/store/actions.js